import { Button, Input } from '@common/components';
import { cn } from '@core/utils';

interface PointUsageSectionProps {
  availablePoints: number;
  usedPoints: number;
  isInsufficient?: boolean;
}

export const PointUsageSection = ({
  availablePoints,
  usedPoints,
  isInsufficient = false,
}: PointUsageSectionProps) => {
  return (
    <section>
      <div className="mb-4 flex h-48 items-center justify-between">
        <h2 className="font-700 text-Gray-900 typo-h6 mobile-tablet:typo-body2">
          웰포인트 사용
        </h2>
        <span className="text-Gray-600 typo-body2 mobile-tablet:font-600 mobile-tablet:typo-caption1">
          보유 : {availablePoints.toLocaleString()}P
        </span>
      </div>

      <div className="flex gap-8">
        <Input
          dimensions="H48"
          readOnly
          value={usedPoints.toLocaleString()}
          className={cn(
            'flex-1 !rounded-none font-500 typo-body2 mobile-tablet:typo-body4',
            isInsufficient
              ? 'border-R-400 text-R-400'
              : 'border-O-400 text-O-400',
          )}
          rightContent={
            <span
              className={cn(
                'font-700',
                isInsufficient ? 'text-R-400' : 'text-O-400',
              )}
            >
              P
            </span>
          }
        />
        <Button
          dimensions="H48"
          theme="sub-line"
          className="!rounded-none border-Gray-900"
          disabled
        >
          전액 사용
        </Button>
      </div>
    </section>
  );
};
